import api from './api'

export const attorneysApi = {
  list: (state = 'CO') => api.get('/v1/attorneys', { params: { state } }).then((r) => r.data),
  submitInquiry: (payload) => api.post('/v1/attorneys/inquiry', payload).then((r) => r.data),
}

export default attorneysApi
